"use strict";

var _interopRequireDefault = require("reshow-runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _objectSpread2 = _interopRequireDefault(require("reshow-runtime/helpers/objectSpread2"));
var _getScrollInfo = _interopRequireDefault(require("get-scroll-info"));
var _isOnScreen = _interopRequireDefault(require("./isOnScreen.js"));
var _getDomPositionInfo2 = _interopRequireDefault(require("./getDomPositionInfo.js"));
var _positions = _interopRequireDefault(require("./positions.js"));
var _type = require("./type.js");
// @ts-check

var T = "T";
var R = "R";
var B = "B";
var L = "L";
var C = "C";

/**
 * @param {string} fromLoc
 * @returns {string}
 */
var getRevertLoc = function getRevertLoc(fromLoc) {
  var loc;
  switch (fromLoc) {
    case _positions["default"].TL:
      loc = _positions["default"].TR;
      break;
    case _positions["default"].TR:
      loc = _positions["default"].TL;
      break;
    case _positions["default"].BL:
      loc = _positions["default"].BR;
      break;
    case _positions["default"].BR:
      loc = _positions["default"].BL;
      break;
    default:
      loc = fromLoc;
      break;
  }
  return loc;
};

/**
 * @param {DomInfoType} domInfo
 * @param {import("get-scroll-info").ScrollInfoType} scrollInfo
 * @returns {CalWindowOffsetResult}
 */
var calWindowOffset = function calWindowOffset(domInfo, scrollInfo) {
  var _distanceFlip;
  var distance = {
    top: domInfo.top - scrollInfo.top,
    right: scrollInfo.right - domInfo.right,
    bottom: scrollInfo.bottom - domInfo.bottom,
    left: domInfo.left - scrollInfo.left
  };
  var maxDistance = Math.max(distance.top, distance.right, distance.bottom, distance.left);
  var distanceFlip = (_distanceFlip = {}, _distanceFlip[distance.top] = T, _distanceFlip[distance.right] = R, _distanceFlip[distance.bottom] = B, _distanceFlip[distance.left] = L, _distanceFlip);
  var firstKey = distanceFlip[maxDistance];
  var secondKey;
  if (firstKey === T || firstKey === B) {
    var _distanceFlip2;
    distanceFlip = (_distanceFlip2 = {}, _distanceFlip2[distance.right] = R, _distanceFlip2[distance.left] = L, _distanceFlip2);
    secondKey = distanceFlip[Math.max(distance.left, distance.right)];
  } else {
    var _distanceFlip3;
    distanceFlip = (_distanceFlip3 = {}, _distanceFlip3[distance.top] = T, _distanceFlip3[distance.bottom] = B, _distanceFlip3);
    secondKey = distanceFlip[Math.max(distance.top, distance.bottom)];
  }
  var locs = [getRevertLoc(_positions["default"][firstKey + secondKey]), _positions["default"][firstKey + C], _positions["default"][secondKey + C], getRevertLoc(_positions["default"][secondKey + firstKey])];
  return {
    locs: locs,
    firstKey: firstKey,
    secondKey: secondKey
  };
};

/**
 * @param {HTMLElement} dom
 * @param {boolean?} [debug]
 * @param {number} [margin]
 * @returns {WindowOffsetType|undefined}
 */
var getWindowOffset = function getWindowOffset(dom, debug, margin) {
  if (!dom) {
    console.warn("getWindowOffset not assign dom");
    return;
  }
  var _getDomPositionInfo = (0, _getDomPositionInfo2["default"])(dom),
    fixedNode = _getDomPositionInfo.fixedNode,
    overflowNode = _getDomPositionInfo.overflowNode,
    domInfo = _getDomPositionInfo.domInfo,
    domOverflowInfo = _getDomPositionInfo.domOverflowInfo;
  var scrollInfo = (0, _getScrollInfo["default"])();
  var cookScrollInfo = (0, _objectSpread2["default"])({}, scrollInfo);
  if (fixedNode) {
    var fixedScrollInfo = (0, _getScrollInfo["default"])( /** @type HTMLElement */fixedNode);
    cookScrollInfo.top = fixedScrollInfo.top;
    cookScrollInfo.right = scrollInfo.scrollNodeWidth;
    cookScrollInfo.bottom = scrollInfo.scrollNodeHeight;
    cookScrollInfo.left = fixedScrollInfo.left;
  } else if (overflowNode) {
    var overflowNodeScrollInfo = (0, _getScrollInfo["default"])(overflowNode);
    cookScrollInfo.top += overflowNodeScrollInfo.top;
    /**
     * @type number
     */
    cookScrollInfo.right += overflowNodeScrollInfo.left;
    /**
     * @type number
     */
    cookScrollInfo.bottom += overflowNodeScrollInfo.top;
    cookScrollInfo.left += overflowNodeScrollInfo.left;
  }
  var domInfoWithScreen = (0, _isOnScreen["default"])(domInfo, cookScrollInfo, margin);
  var domOverflowInfoWithScreen = (0, _isOnScreen["default"])(domOverflowInfo, (0, _getScrollInfo["default"])(domOverflowInfo.domScroller), margin);
  domInfoWithScreen.isOnScreen = domInfoWithScreen.isOnScreen && domOverflowInfoWithScreen.isOnScreen;
  if (!domInfoWithScreen.isOnScreen && false !== debug || true === debug) {
    // should not break function here
    // not use return here
    console.warn(domInfoWithScreen.isOnScreen ? "Dom is in screen" : "Dom is not in screen", {
      dom: dom,
      domInfo: domInfo,
      scrollInfo: scrollInfo,
      cookScrollInfo: cookScrollInfo
    });
  }
  var result = (0, _objectSpread2["default"])({
    domInfo: domInfoWithScreen,
    domOverflowInfo: domOverflowInfoWithScreen,
    scrollInfo: scrollInfo
  }, calWindowOffset(domInfo, cookScrollInfo));
  return result;
};
var _default = exports["default"] = getWindowOffset;
module.exports = exports.default;